// extracted by mini-css-extract-plugin
export default {"widget":"LaunchPageWidget_widget__o5EkP","title":"LaunchPageWidget_title__MlaD9"};